export default __webpack_public_path__ + "images/3a3224eaab20cf4b09c66f71aa44dd66.svg";